import React from 'react'

export const stopPropagating = (callback?: (event: React.SyntheticEvent) => void) => (event: React.SyntheticEvent) => {
  event.stopPropagation()
  callback?.(event)
}
